<script setup>
import Logo from '@/components/logo/components/Logo.vue';
import { router } from '@/router/index';

function getMenuItemOpenClass(item) {
    const className = router.currentRoute.value.path.startsWith(item) ? ' active' : '';
    return className;
}

</script>

<template>
    <!-- Main Sidebar Container -->
    <aside class="main-sidebar sidebar-light-primary elevation-2">
        <!-- Brand Logo -->
        <Logo />
        <!-- Sidebar -->
        <div class="sidebar">
            <nav class="mt-2">
                <ul class="nav nav-pills nav-sidebar flex-column nav-compact " data-widget="treeview" role="menu" data-accordion="false">
                    <li class="nav-item menu-open">
                        <router-link to="/user/profile" class="nav-link" :class="getMenuItemOpenClass('/user/profile')">
                            <i class="nav-icon fas fa-user-cog"></i>
                            <p>Profilo</p>
                        </router-link>
                        <router-link to="/user/notifications" class="nav-link" :class="getMenuItemOpenClass('/user/notifications')">
                            <i class="nav-icon fas fa-comments"></i>
                            <p>Notifiche</p>
                        </router-link>
                    </li>
                </ul>
            </nav>
        </div>
    </aside>
    <div class="content-wrapper">
        <!-- Main content / -->
        <router-view></router-view>
    </div>
    
    <footer class="main-footer">
    © <strong>More News</strong>

  </footer>
    
</template>
